<template>
  <div>
    <top />

    <div class="home clearfix">
      <div class="main_left fl" v-if="windowWidth > 769">
        <div class="linecss" v-for="fieldItem in fieldSorts" :key="fieldItem.uid">
          <div class="clearfix" style="width: 215px">
            <h2 class="icon icon_css fl">{{ fieldItem.text }}</h2>
            <img src="@/assets/imgs/rightbtn.png" class="fr" style="margin-top: 9px" />
          </div>
          <ul>
            <li v-for="item in fieldItem.newChildren || fieldItem.children" :key="item.uid">
              <div v-show="item.isPresent">
                <router-link v-if="
                  currentPath.indexOf('allReport') !== -1 ||
                  currentUid === '全部报告'
                " :to="{
                    path: '/allReports',
                    query: { id: item.uid, idname: item.text },
                  }" class="a" :class="{ leftHover: item.uid === currentId }"
                  @click.native="getFieldname(item.text)">{{ item.text }}</router-link>
                <router-link v-if="
                  currentPath.indexOf('allReport') === -1 &&
                  currentUid !== '全部报告'
                " :to="{
                    path: currentPath,
                    query: { uid: currentUid, id: item.uid, idname: item.text },
                  }" class="a" :class="{ leftHover: item.uid === currentId }"
                  @click.native="getFieldname(item.text)">{{ item.text }}</router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <van-popup v-model="filterState" closeable round position="bottom" :style="{ height: '45%' }"
        get-container=".header">
        <div class="linecss" v-for="fieldItem in fieldSorts" :key="fieldItem.uid">
          <div class="clearfix" style="width: 215px">
            <h2 class="m-filter-title fl">{{ fieldItem.text }}</h2>
          </div>
          <ul>
            <li v-for="item in fieldItem.newChildren || fieldItem.children" :key="item.uid"
              style="display: inline-block">
              <div v-show="item.isPresent">
                <router-link v-if="
                  currentPath.indexOf('allReport') !== -1 ||
                  currentUid === '全部报告'
                " :to="{
                    path: '/allReports',
                    query: { id: item.uid, idname: item.text },
                  }" class="a" :class="{ leftHover: item.uid === currentId }"
                  @click.native="getFieldname(item.text)">{{ item.text }}</router-link>
                <router-link v-if="
                  currentPath.indexOf('allReport') === -1 &&
                  currentUid !== '全部报告'
                " :to="{
                    path: currentPath,
                    query: { uid: currentUid, id: item.uid, idname: item.text },
                  }" class="a" :class="{ leftHover: item.uid === currentId }"
                  @click.native="getFieldname(item.text)">{{ item.text }}</router-link>
              </div>
            </li>
          </ul>
        </div>
      </van-popup>
      <div class="main_right fr">
        <div class="m-filter" v-if="windowWidth < 769">
          <van-icon name="filter-o" size="30" color="#999" :class="[filterState ? 'popAnimist' : '']"
            @click="showFilterPopup" />
        </div>
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/Top";
import Footer from "@/components/Footer";
import { api } from "@/pages/index/require/api.js";
import { setFieldname } from "@/pages/index/require/auth";
export default {
  components: {
    Top,
    Footer,
  },
  data() {
    return {
      fieldSorts: [],
      currentPath: "",
      currentUid: "",
      currentId: "",
      filterState: false,
    };
  },
  created() {
    this.currentPath = this.$route.path;
    this.currentUid = this.$route.query.uid;
    this.currentId = this.$route.query.id;
    // (this.currentUid === '全部报告' || this.currentUid === undefined) ? this.loadFieldSorts() : this.loadSecondFieldSorts();
    this.$route.name.indexOf("allReport") !== -1 ||
      this.currentUid === "全部报告"
      ? this.loadFieldSorts()
      : this.loadSecondFieldSorts();
  },
  watch: {
    $route() {
      this.currentPath = this.$route.path;
      this.currentUid = this.$route.query.uid;
      this.currentId = this.$route.query.id;
      // (this.currentUid === '全部报告' || this.currentUid === undefined) ? this.loadFieldSorts() : this.loadSecondFieldSorts();
      this.$route.name.indexOf("allReport") !== -1 ||
        this.currentUid === "全部报告"
        ? this.loadFieldSorts()
        : this.loadSecondFieldSorts();
    },
  },
  methods: {
    async loadSecondFieldSorts() {
      const { code, data } = await api.get(
        "/indexController/getSecondFieldSorts",
        {
          reportTypeName: this.currentUid,
        }
      );
      if (code === 0) {
        // this.fieldSorts = data;
        this.fieldSorts = this.moveToFirst(data);
      }
    },
    moveToFirst(arr) {
      const index = arr.findIndex(item => item.uid === '9008');
      if (index !== -1) {
        const [item] = arr.splice(index, 1); // 移除该元素
        arr.unshift(item); // 添加到数组开头
      }
      return arr;
    },
    async loadFieldSorts() {
      const { code, data } = await api.get("/indexController/getFieldSorts");
      if (code === 0) {
        this.fieldSorts = data;
      }
    },
    getFieldname(val) {
      setFieldname(val);
    },
    showFilterPopup() {
      this.filterState = !this.filterState;
    },
  },
};
</script>

<style lang='less' scoped>
.main_left {
  border: 1px solid #015d9e;
  width: 270px;
  border-top: none;
  padding: 20px;

  .linecss {
    border-left: 1px dashed #a4a4a4;
    margin-left: 10px;
  }

  ul a {
    padding-left: 24px;
    color: #373737;
    font-size: 15px;
    line-height: 30px;
  }

  li:hover a {
    color: #0770b9;
    cursor: pointer;
    font-weight: 700;
  }
}

.main_right {
  width: 890px;
}

.leftHover {
  color: #0770b9 !important;
  font-weight: 700;
}

@media screen and (max-width: 769px) {
  .main_left {
    width: 100%;
    background-color: #015d9e;
  }

  .linecss {
    padding: 0 16px;
    margin-bottom: 16px;

    &:first-child {
      margin-top: 40px;
    }

    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      li {
        padding: 6px 16px;
        border: 1px dashed #ddd;
        border-radius: 20px;
        margin-bottom: 8px;
        margin-right: 8px;

        .a {
          color: #333;
          font-size: 12px;
        }
      }
    }
  }

  .m-filter-title {
    font-size: 16px;
    font-weight: 600;
  }

  .main_right {
    width: 100%;
    position: relative;

    .m-filter {
      position: absolute;
      right: 16px;
      top: 20px;
    }
  }

  .popAnimist {
    -webkit-animation: jello-horizontal 0.4s both;
    animation: jello-horizontal 0.4s both;
  }
}

@-webkit-keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }

  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }

  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
</style>